import {Methodology} from '@app/models/methodology.model';

export class MethodologyUsed {
  methodologiesUsed: Methodology[];

  methodologiesUsedOther: string;

  literatureSearchKeywords: string;

  literatureSearchTypes: string;

  literatureSearchInclusionsExclusions: string;

  literatureSearchPeriod: string;

  literatureSearchFullTextAbstract: string;

  literatureSearchPrecisions: string;

  qualitativeSearchTarget: string;

  qualitativeSearchTools: string;

  qualitativeSearchAnalyseType: string;

  qualitativeSearchRecordingAndAnonymization: string;

  quantitativeSearchTarget: string;

  quantitativeSearchRecruitmentMethod: string;

  quantitativeSearchSamplingType: string;

  quantitativeSearchAnalyseProcess: string;

  quantitativeSearchAnonymizationProcess: string;

  qualityInsuranceTarget: string;

  qualityInsuranceType: string;

  actionSearchTarget: string;

  actionSearchType: string;

  otherMethodologyTarget: string;

  otherMethodologyExplain: string;

  clinicResearch: boolean;

  clinicResearchTarget: string;

  clinicResearchInclusionExclusion: string;

  clinicResearchIntervention: string;

  clinicResearchComparator: string;

  clinicResearchExplain: string;
}
